/** @jsxImportSource @emotion/react */
import { EmptyContent, Header } from '@quickbit/backoffice-core-frontend';
import {
  createStyles,
  Loader,
  Typography,
  UtilityButton,
} from '@quickbit/qb-design-system';
import { Route, Routes } from 'react-router-dom';
import { ContactsTable, TransactionsTable } from '../components';
import { useGetPendingItems } from './api';

const ManualReviewContent = () => {
  const styles = useStyles();
  const { data, isLoading, isError, refetch } = useGetPendingItems();

  if (isLoading) {
    return (
      <div css={styles.loadingContainer}>
        <Loader />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <EmptyContent
        heading="Oops! Something went wrong."
        body="Error fetching pending items"
        action={
          <UtilityButton
            text="Try again"
            variant="primary"
            onClick={() => void refetch()}
          />
        }
      />
    );
  }

  const hasContacts = data.contacts.length > 0;
  const hasTransactions = data.transactions.length > 0;
  const hasAnyItems = hasContacts || hasTransactions;

  if (!hasAnyItems) {
    return (
      <>
        <Header>
          <Typography variant="subtitle">FCU</Typography>
        </Header>
        <EmptyContent
          heading="No pending items"
          body="There are no items pending FCU review"
        />
      </>
    );
  }

  return (
    <>
      <Header>
        <Typography variant="subtitle">FCU</Typography>
      </Header>
      <div css={styles.tablesContainer}>
        {hasContacts && (
          <ContactsTable contacts={data.contacts} refetch={refetch} />
        )}
        {hasTransactions && (
          <TransactionsTable
            transactions={data.transactions}
            refetch={refetch}
          />
        )}
      </div>
    </>
  );
};

export const ManualReview = () => {
  return (
    <Routes>
      <Route path="/" element={<ManualReviewContent />} />
    </Routes>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
  },
  tablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.m,
  },
}));
